// Timer preset settings
export const TIMER_PRESETS = {
  classic: {
    name: "Classic Pomodoro",
    workDuration: 25 * 60,
    shortBreakDuration: 5 * 60,
    totalSessions: 4,
    totalDuration: 115 * 60, // 4×25min + 3×5min = 115 minutes
  },
  quick: {
    name: "Quick Sessions",
    workDuration: 15 * 60,
    shortBreakDuration: 3 * 60,
    totalSessions: 6,
    totalDuration: 105 * 60, // 6×15min + 5×3min = 105 minutes
  },
  deepWork: {
    name: "Deep Work",
    workDuration: 45 * 60,
    shortBreakDuration: 8 * 60,
    totalSessions: 3,
    totalDuration: 151 * 60, // 3×45min + 2×8min = 151 minutes
  },
  professional: {
    name: "Professional",
    workDuration: 50 * 60,
    shortBreakDuration: 10 * 60,
    totalSessions: 2,
    totalDuration: 110 * 60, // 2×50min + 1×10min = 110 minutes
  },
};

export type PresetType = keyof typeof TIMER_PRESETS;

// Help text for the Pomodoro Technique
export const HELP_TEXT = {
  introduction: `The Pomodoro Technique is a time management method that uses a timer to break work into focused intervals, traditionally 25 minutes in length, separated by short breaks. These intervals are known as "pomodoros."`,
  presets: {
    classic:
      "25-minute focus with 5-minute breaks. Perfect for beginners and most tasks. Complete 4 sessions for variety and momentum.",
    quick:
      "15-minute focus with 3-minute breaks. Ideal for high-energy tasks or when you need more frequent breaks. Complete 6 sessions for variety and momentum.",
    deepWork:
      "45-minute focus with 8-minute breaks. Designed for complex tasks requiring deep concentration. Complete 3 intensive sessions for maximum depth.",
    professional:
      "50-minute focus with 10-minute breaks. Suited for experienced users and sustained professional work. Complete 2 extended sessions for efficiency.",
  },
}; 